import { Text, Flex, Box, Icon, OrderedList, ListItem } from "@chakra-ui/react";

// Import spring animations
import { useSpring, animated } from "@react-spring/web";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet-async";

const Info = () => {
  // Define spring animation using the useSpring hook
  const springs = useSpring({
    from: { x: -1000 }, // Initial position (x) for animation
    to: { x: 0 }, // Target position (x) for animation
  });

  return (
    <animated.section style={{ ...springs }}>
      <Helmet>
        <title>Info Controluce</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Scopri i nostri termini e condizioni e la nostra privacy policy."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Legals",
            name: "Privacy policy, termini & condizioni di Controluce Illuminazione",
            image: [
              "https://www.controluceilluminazione.it/static/media/controluceLogoRWhite.e12538b1615ec247c4cc.png",
              "https://controluceilluminazione.it/static/media/controluceLogoLWhite.e92eabff7d445a556cd2.png",
            ],
            telephone: "+39 055 0935053",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Firenze",
              postalCode: "50018",
              streetAddress: "Via di casellina",
            },
            url: "https://www.controluceilluminazione.it",
            openingHours: "Mo-Fr 09:00-18:00",
            geo: {
              "@type": "GeoCoordinates",
              latitude: "43.7583291",
              longitude: "11.1626199",
            },
            sameAs: [
              "https://www.facebook.com/p/Controluce-Illuminazione-100043546856066",
              "http://instagram.com/controluce_illuminazione/#",
            ],
          })}
        </script>
      </Helmet>
      <Box minH={"100vh"}>
        <Box background={"ambra"} h={"0.5em"}></Box>

        <Flex p={{ base: "2em" }} direction={"column"} justify={"center"}>
          <Text fontSize={{ base: "1.618em" }} mt={{ base: "0.7em" }}>
            📄 Integrazione alla privacy policy generata da Iubenda{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/20133443"
              className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Privacy Policy "
            >
              Privacy Policy
            </a>{" "}
          </Text>
          <Text>Ultimo aggiornamento: 10/6/2025</Text>
          <Text>
            La presente informativa è resa ai sensi dell’art. 13 del Regolamento
            (UE) 2016/679 (GDPR) a coloro che interagiscono con il sito web
            www.controluceilluminazione.it.
          </Text>
          <Text mb={4}>
            Questo documento integra la Privacy Policy principale gestita da
            Iubenda specificando il trattamento dei dati attraverso il modulo di
            contatto.{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/20133443"
              className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Privacy Policy "
            >
              Privacy Policy
            </a>{" "}
          </Text>
          <OrderedList>
            <ListItem mb={{ base: "0.5em" }}>
              Titolare del trattamento
              <br /> Il titolare del trattamento è: Controluce Illuminazione di
              Monti Daniele. Sede legale: Scandicci(FI), Via di casellina snc,
              CAP 50018, Isola e interno piano terra, stradario 06680. P.IVA:
              04758120481 {/* TODO: Inserire mail aziendale ?*/}
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Dati trattati
              <br /> I dati trattati sono quelli forniti volontariamente
              dall’utente tramite il form di contatto: Nome, Indirizzo email e
              messaggio.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Finalità del trattamento
              <br /> I dati sono raccolti per: rispondere a richieste di
              informazioni; inviare preventivi; gestire eventuali richieste di
              collaborazione.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Cookie e strumenti di tracciamento
              <br />I link ai social network (es. Facebook, Instagram) presenti
              sul sito sono semplici collegamenti esterni e non comportano
              l’installazione di cookie da parte delle piattaforme collegate.{" "}
              <br />
              Modulo di contatto (EmailJS) Il modulo di contatto è gestito
              tramite il servizio EmailJS, che consente l’invio automatico del
              messaggio all’indirizzo email del Titolare. EmailJS non installa
              cookie sul browser al momento dell'utilizzo sul nostro sito web
              (www.controluceilluminazione.it), i dati vengono utilizzati solo
              al momento dell’invio del messaggio e trasmessi in modo sicuro.
              Per maggiori dettagli su i cookie utilizzati{" "}
              <a
                href="https://www.iubenda.com/privacy-policy/20133443/cookie-policy"
                className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
                title="Cookie Policy "
              >
                Cookie Policy
              </a>
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Base giuridica
              <br /> Il trattamento si basa sul consenso esplicito
              dell’interessato, richiesto prima dell'invio della richiesta
              tramite il form dei contatti ed obbligatorio ai fini dell'invio
              delle informazioni inserite da parte dell'utente (art. 6, par. 1,
              lett. a GDPR).
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Modalità di trattamento
              <br /> Il trattamento avviene con strumenti informatici, nel
              rispetto delle misure di sicurezza previste dalla normativa.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Destinatari
              <br /> I dati vengono inviati via email tramite il servizio
              EmailJS. EmailJS potrebbe trattare i dati come responsabile del
              trattamento. Consulta la loro{" "}
              <Box as={"span"} textDecor={"none"} _hover={{ color: "ambra" }}>
                <Link
                  target={"_blank"}
                  to={"https://www.emailjs.com/legal/privacy-policy/"}
                >
                  Privacy Policy
                </Link>
                <Icon
                  m={{
                    base: "0.1em 0 0 0.3em",
                  }}
                  viewBox="0 0 24 24"
                >
                  {" "}
                  {/* TODO: RISOLVI PROBLE COLORE */}
                  <path
                    d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                  <path
                    d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                </Icon>
              </Box>
              .
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Trasferimento dati extra UE
              <br /> I dati potrebbero essere trasferiti verso paesi extra-UE
              (es. USA, dove ha sede EmailJS), con adeguate garanzie (es.
              clausole contrattuali standard).
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Durata di conservazione
              <br /> I dati saranno conservati per il tempo necessario a gestire
              la richiesta e successivamente cancellati.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Diritti dell’utente
              <br /> L’utente può, in qualsiasi momento, esercitare i propri
              diritti ai sensi degli articoli 15-22 del GDPR, tra cui: Accesso
              ai dati, Rettifica o cancellazione, Limitazione del trattamento,
              Opposizione al trattamento, Portabilità dei dati. Le richieste
              vanno inviate via email al Titolare.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Reclami <br />
              L’interessato ha diritto di proporre reclamo all’Autorità Garante
              per la Protezione dei Dati Personali: www.garanteprivacy.it
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Contatti per qualsiasi richiesta: danielschiraldi09@gmail.com
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Contatti <br /> per qualsiasi richiesta utilizzare il form dei{" "}
              <Box as={"span"} textDecor={"none"} _hover={{ color: "ambra" }}>
                <Link to={"/contact"}>contatti</Link>.
                <Icon
                  m={{
                    base: "0.1em 0 0 0.3em",
                  }}
                  viewBox="0 0 24 24"
                >
                  {" "}
                  {/* TODO: RISOLVI PROBLE COLORE */}
                  <path
                    d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                  <path
                    d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                </Icon>
              </Box>
            </ListItem>
          </OrderedList>
        </Flex>
        <Flex p={{ base: "2em" }} direction={"column"} justify={"center"}>
          <Text fontSize={{ base: "1.618em" }} mt={{ base: "0.7em" }}>
            📜 Termini e Condizioni d’Uso del Sito
          </Text>
          <Text>Ultimo aggiornamento: 20/05/2025</Text>
          <Text>
            La presente informativa è resa ai sensi dell’art. 13 del Regolamento
            (UE) 2016/679 (GDPR) a coloro che interagiscono con il sito web
            www.controluceilluminazione.it.
          </Text>
          <OrderedList>
            <ListItem mb={{ base: "0.5em" }}>
              Oggetto :
              <br /> Il presente sito ha finalità informative e promozionali.
              Non effettua vendita diretta online.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Richieste tramite form :
              <br /> Le richieste inviate tramite il modulo di contatto: non
              costituiscono contratto; non comportano obblighi reciproci;
              saranno trattate per finalità informative e/o per eventuali
              preventivi.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Diritti e contenuti :
              <br /> Tutti i testi, immagini e materiali presenti nel sito sono
              di proprietà di Controluce Illuminazione di Monti Daniele, o
              utilizzati con licenza. È vietata la riproduzione non autorizzata.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Responsabilità :
              <br /> Pur curando l’aggiornamento dei contenuti, l’azienda non
              garantisce l’assenza di errori o interruzioni nel sito. L’uso del
              sito è a rischio dell’utente.
            </ListItem>
            <ListItem mb={{ base: "0.5em" }}>
              Modifiche :
              <br /> I presenti termini possono essere modificati in qualsiasi
              momento. L’uso del sito dopo le modifiche implica accettazione.
            </ListItem>
          </OrderedList>
        </Flex>
      </Box>
    </animated.section>
  );
};

export default Info;
